export default "__VITE_ASSET__DwTxacXp__"